/**
 * Constants for guest/demo mode
 */

/**
 * The fixed user ID used for guest mode.
 * This is a valid UUID format but represents the guest/demo user.
 */
export const GUEST_USER_ID = '00000000-0000-0000-0000-000000000001'

/**
 * The display name for the guest user
 */
export const GUEST_USER_NAME = 'Usuário Demo'

/**
 * localStorage key for guest database snapshot
 */
export const GUEST_DB_STORAGE_KEY = 'macroflows_guest_db_v1'
